import styled from 'styled-components';

export const ErrorHandler = styled.div`
    position: fixed;
    bottom: 0;
    left: 30px;
    height: 40px;
    padding: 10px;
    box-sizing: border-box;
    z-index: 1000;
    opacity: 0;
    color: #aaa;
    transform: translate3d(0, 100%, 0);
    transition: all .3s ease 0s;
    border: 1px solid #d00;
    background-color: #600;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;

    &.active {
        opacity: 1;
        transform: translate3d(0, -30px, 0);
    }
`;

export const Button = styled.div`
    color: #fff;
    margin-left: 20px;
    border-left: 1px solid #d00;
    padding: 5px 10px;
    cursor: pointer;
    transition: all .4s ease 0s;

    &.noMargin {
        margin-left: 0;
    }

    &:hover {
        color: #faa;
    }
`;

export const ErrorPage = styled.div`
    height: 100%;
    width: 100%;
    color: #fff;
    background-color: #222;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
`;
